import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import getServerSideAPIProps from '../props/getServerSideAPIProps'
import IframeResizer from 'iframe-resizer-react'

export default function Index(lazyProps) {
  const onResized = data => console.log(data)

  return (
    <div>
      <IframeResizer
        frameBorder="0"
        heightCalculationMethod="lowestElement"
        inPageLinks
        log
        src="https://forms.zohopublic.com/bottlepos/form/BottleZooSignUp/formperma/IOe7UTM80P4RgZW9qw-FppNRkwG48XhF5LWBtXlREUk"
        style={{ minWidth: '100%', height: '1168px' }}
        onResized={onResized}
      />
    </div>
  )
}

export const getServerSideProps = getServerSideAPIProps('/getlisted')
